"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleProvider = exports.useContextLocale = void 0;
const storage_1 = require("./storage");
const react_1 = __importStar(require("react"));
const locale_1 = require("utils/locale");
const LocaleContext = react_1.default.createContext(null);
const useContextLocale = () => {
    return (0, react_1.useContext)(LocaleContext);
};
exports.useContextLocale = useContextLocale;
const LocaleProvider = ({ children, localeStorageKey = "locale", }) => {
    const [locale, setLocale] = (0, storage_1.useSessionStorage)(localeStorageKey, locale_1.searchParamLocale || locale_1.browserLocale, Boolean(locale_1.searchParamLocale));
    return (react_1.default.createElement(LocaleContext.Provider, { value: [locale, setLocale] }, children));
};
exports.LocaleProvider = LocaleProvider;
